import { useCallback } from 'react';

import type { PageMessage } from '../../../../types/PageMessage';
import type { ComboBoxOption } from '../../../cdl/ComboBox/ComboBox';
import { getProductsByQuery } from '../../../common/api/clients/product.api';

export const useLoadProductsForSupplierGroup = (excludedProductId?: string) => {
    return useCallback(
        async (
            supplierProductGroup: string,
            searchQuery: string,
            page: number
        ): Promise<PageMessage<ComboBoxOption>> => {
            const productsPage = await getProductsByQuery({
                page,
                searchQuery: searchQuery ?? '',
                supplierProductGroups: [supplierProductGroup],
            });

            return {
                ...productsPage,
                content: productsPage.content
                    .filter((candidate) => candidate.id !== excludedProductId)
                    .map((candidate) => ({
                        value: candidate.id,
                        label: candidate.name,
                    })),
            };
        },
        [excludedProductId]
    );
};
